import { UIButton, UIModal, UIModalProps, UITypography } from 'shared/ui';
import styles from './style.module.scss';
import { formatLargeNumber } from 'shared/utils';
import { TokenData } from 'shared/constants/tokens';

export const AmountWithTokenData = ({
  amount,
  token,
  decimals = 8,
  tokenTitle = true,
}: {
  amount: string;
  token: TokenData;
  decimals?: number;
  tokenTitle?: boolean;
}) => {
  return (
    <div className={styles.amountWithToken}>
      <span>{formatLargeNumber(amount, decimals)}</span>
      <img src={token.logoURI} alt="" className={styles.tokenIcon} />
      {tokenTitle && <span>{token.symbol}</span>}
    </div>
  );
};
